export const CalculateUserCategory = (user) => {
  if (!user) {
    return "Operativa"; // Categoría por defecto
  }
  
  const area = user.area?.toUpperCase();
  
  switch (area) {
    case "ADMINISTRACION":
      return "Administración";
    case "COMERCIAL":
      return "Comercial";
    default:
      return "Operativa"; // Categoría por defecto
  }
};